// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 42-app-marketplace.md
import * as React from 'react';

import { cn } from '@/lib/utils';

interface PendingCountBadgeProps {
  count: number;
  /** Screen-reader label; visually the pill shows only the number. */
  label: string;
  className?: string;
}

/**
 * Small numeric pill for "N pending" counts — the app-detail Access tab
 * trigger, the Access requests card header, and an app's row on the /apps
 * list (docs/42 §Access requests) all show the same shape. Renders nothing
 * when count is 0, so callers can mount it unconditionally.
 */
export function PendingCountBadge({
  count,
  label,
  className,
}: PendingCountBadgeProps): React.JSX.Element | null {
  if (count <= 0) return null;
  return (
    <span
      className={cn(
        'inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-[hsl(var(--status-amber)/0.18)] px-1 font-mono text-[10px] text-foreground',
        className,
      )}
      aria-label={label}
    >
      {count}
    </span>
  );
}
